import * as HELP_ACTION from 'constant/action/help'
import { handleActions } from 'redux-actions'

const initialState = {
  help: {}
}

export default handleActions(
  {
    [HELP_ACTION.UPDATE_HELP_CONTENT]: (state, action) => ({
      ...state,
      help: action.payload
    })
  },
  initialState
)
